<template>
  <div class="container">
    <!-- PI소식 섹션 -->
    <section class="board-section">
      <div class="section-header">
        <h2>PI소식</h2>
        <router-link to="/news" class="view-more">
          더보기 
          <i class="fas fa-chevron-right"></i>
        </router-link>
      </div>
      <div class="card-container">
        <div v-for="item in newsItems" 
             :key="item.id" 
             class="card"
             @click="viewNews(item.id)">
          <div class="card-image" :style="{ backgroundImage: `url(${item.image})` }"></div>
          <div class="card-content">
            <h3>{{ item.title }}</h3>
            <p class="card-desc">{{ item.description }}</p>
            <div class="card-info">
              <span><i class="far fa-calendar"></i> {{ item.date }}</span>
              <span><i class="far fa-eye"></i> {{ item.views }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 커뮤니티 섹션 -->
    <section class="board-section">
      <div class="section-header">
        <h2>커뮤니티</h2>
        <router-link to="/community" class="view-more">
          더보기 
          <i class="fas fa-chevron-right"></i>
        </router-link>
      </div>
      <div class="community-list">
        <div v-for="post in communityPosts" 
             :key="post.id" 
             class="community-item"
             @click="viewPost(post.id)">
          <div class="post-content">
            <h3>{{ post.title }}</h3>
            <p class="post-preview">{{ post.content }}</p>
          </div>
          <div class="post-info">
            <span class="author">
              <i class="far fa-user"></i> {{ post.author }}
            </span>
            <div class="post-stats">
              <span><i class="far fa-comment"></i> {{ post.comments }}</span>
              <span><i class="far fa-heart"></i> {{ post.likes }}</span>
              <span><i class="far fa-eye"></i> {{ post.views }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'MainHome',
  data() {
    return {
      newsItems: [
        {
          id: 1,
          title: '2024 PI 개발자 컨퍼런스 개최 안내',
          description: '올해의 PI 개발자 컨퍼런스가 서울에서 개최됩니다.',
          image: 'https://picsum.photos/300/200',
          date: '2024-03-19',
          views: 156
        },
        {
          id: 2,
          title: 'PI 플랫폼 최신 업데이트 소식',
          description: '새로운 기능과 개선된 성능으로 찾아왔습니다.',
          image: 'https://picsum.photos/300/200',
          date: '2024-03-18',
          views: 98
        },
        // ... 추가 뉴스 아이템
      ],
      communityPosts: [
        {
          id: 1,
          title: 'PI 개발 초보자 질문입니다',
          content: '처음 시작하는데 어떤 것부터 배워야 할까요?',
          author: '홍길동',
          comments: 12,
          likes: 24,
          views: 234
        },
        {
          id: 2,
          title: '프로젝트 팀원 모집합니다',
          content: 'PI를 활용한 새로운 프로젝트를 함께할 팀원을 찾습니다.',
          author: '김철수',
          comments: 8,
          likes: 15,
          views: 187
        },
        // ... 추가 커뮤니티 포스트
      ]
    }
  },
  methods: {
    viewNews(id) {
      console.log('뉴스 상세 보기:', id)
    },
    viewPost(id) {
      console.log('게시글 상세 보기:', id)
    }
  }
}
</script>

<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.board-section {
  margin-bottom: 40px;
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.section-header h2 {
  font-size: 24px;
  font-weight: 600;
  color: #2c3e50;
}

.view-more {
  text-decoration: none;
  color: #666;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 4px;
  transition: color 0.3s;
}

.view-more:hover {
  color: #42b983;
}

/* PI소식 카드 스타일 */
.card-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 24px;
}

.card {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.3s, box-shadow 0.3s;
  cursor: pointer;
}

.card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.card-image {
  height: 160px;
  background-size: cover;
  background-position: center;
}

.card-content {
  padding: 16px;
}

.card-content h3 {
  margin: 0 0 8px 0;
  font-size: 18px;
  color: #2c3e50;
}

.card-desc {
  font-size: 14px;
  color: #666;
  margin-bottom: 12px;
  line-height: 1.4;
}

.card-info {
  display: flex;
  justify-content: space-between;
  color: #999;
  font-size: 12px;
}

/* 커뮤니티 리스트 스타일 */
.community-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.community-item {
  padding: 16px;
  background: #f8f9fa;
  border-radius: 8px;
  cursor: pointer;
  transition: transform 0.3s, background-color 0.3s;
}

.community-item:hover {
  transform: translateX(4px);
  background-color: #f0f2f5;
}

.post-content h3 {
  margin: 0 0 8px 0;
  font-size: 16px;
  color: #2c3e50;
}

.post-preview {
  font-size: 14px;
  color: #666;
  margin-bottom: 12px;
}

.post-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  color: #999;
}

.post-stats {
  display: flex;
  gap: 12px;
}

/* 반응형 디자인 */
@media (max-width: 768px) {
  .container {
    padding: 12px;
  }

  .board-section {
    padding: 16px;
    margin-bottom: 20px;
  }

  .card-container {
    grid-template-columns: 1fr;
  }

  .section-header h2 {
    font-size: 20px;
  }
}
</style>
